import { render, staticRenderFns } from "./AnaliseCobrancas.vue?vue&type=template&id=b6954566&scoped=true"
import script from "./AnaliseCobrancas.vue?vue&type=script&lang=js"
export * from "./AnaliseCobrancas.vue?vue&type=script&lang=js"
import style0 from "./AnaliseCobrancas.vue?vue&type=style&index=0&id=b6954566&prod&lang=css"
import style1 from "./AnaliseCobrancas.vue?vue&type=style&index=1&id=b6954566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6954566",
  null
  
)

export default component.exports